import { useRef, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  faCheck,
  faTimes,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
const baseURL = process.env.REACT_APP_API;
const PWD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%]).{8,24}$/;
const CONFIRMATION_URL = baseURL + "auth/users/reset_password_confirm/";

const HOME_PAGE_LINK = process.env.REACT_APP_URL + "login";

const ResetPasswordConfirmation = (props) => {
  const { uid, token } = useParams();
  const pwdRef = useRef();
  const errRef = useRef();
  //const [user, setUser] = useState("");
  //const [validName, setValidName] = useState(false);
  //const [userFocus, setUserFocus] = useState(false);

  const [pwd, setPwd] = useState("");
  const [validPwd, setValidPwd] = useState(false);
  const [pwdFocus, setPwdFocus] = useState(false);

  const [matchPwd, setMatchPwd] = useState("");
  const [validMatch, setValidMatch] = useState(false);
  const [matchFocus, setMatchFocus] = useState(false);

  const [errMsg, setErrMsg] = useState("");
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    pwdRef.current.focus();
    document.body.classList.add("accountBodyColor");

    // Clean up function to remove the class when the component unmounts
    return () => {
      document.body.classList.remove("accountBodyColor");
    };
  }, []);

  useEffect(() => {
    setValidPwd(PWD_REGEX.test(pwd));
    setValidMatch(pwd === matchPwd);
  }, [pwd, matchPwd]);

  useEffect(() => {
    setErrMsg("");
  }, [pwd, matchPwd]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const v2 = PWD_REGEX.test(pwd);

    const resetUser = {
      uid: uid,
      token: token,
      new_password: pwd,
    };
    if (!v2) {
      setErrMsg(" לא תקין");
      return;
    }
    try {
      const response = await axios.post(CONFIRMATION_URL, resetUser);
      setSuccess(true);
      //clear state and controlled inputs
      //need value attrib on inputs for this
      setPwd("");
      setMatchPwd("");
    } catch (err) {
      if (!err?.response) {
        setErrMsg("No Server Response");
      } else if (err.response?.status === 400) {
        setErrMsg("Bad Request");
      } else {
        setErrMsg("Reset Password Failed");
      }
      errRef.current.focus();
    }
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        {success ? (
          <section
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center", // This centers the text inside elements
            }}
          >
            <h1>התהליך עבר בהצלחה!</h1>
            <p>
              <a href={HOME_PAGE_LINK}>דף הבית</a>
            </p>
          </section>
        ) : (
          <section
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <p
              ref={errRef}
              className={errMsg ? "errmsg" : "offscreen"}
              aria-live="assertive"
            >
              {errMsg}
            </p>
            <h1>איפוס סיסמה</h1>
            <form className="accountForm" onSubmit={handleSubmit}>
              <label htmlFor="password">
                סיסמה:
                <FontAwesomeIcon
                  icon={faCheck}
                  className={validPwd ? "valid" : "hide"}
                />
                <FontAwesomeIcon
                  icon={faTimes}
                  className={validPwd || !pwd ? "hide" : "invalid"}
                />
              </label>
              <input
                type="password"
                id="password"
                onChange={(e) => setPwd(e.target.value)}
                value={pwd}
                ref={pwdRef}
                required
                aria-invalid={validPwd ? "false" : "true"}
                aria-describedby="pwdnote"
                onFocus={() => setPwdFocus(true)}
                onBlur={() => setPwdFocus(false)}
              />
              <p
                id="pwdnote"
                className={pwdFocus && !validPwd ? "instructions" : "offscreen"}
              >
                <FontAwesomeIcon icon={faInfoCircle} />
                8 עד 24 תוים.
                <br />
                צריך להכיל אותיות גדולות וקטנות באנגלית, מספרים ותו מיוחד.
                <br />
                תוים מיוחדים מותרים:{" "}
                <span aria-label="exclamation mark">!</span>{" "}
                <span aria-label="at symbol">@</span>{" "}
                <span aria-label="hashtag">#</span>{" "}
                <span aria-label="dollar sign">$</span>{" "}
                <span aria-label="percent">%</span>
                <label>
                  -ת"ז-אסור שהסיסמה תהיה דומה לדואר האלקטרוני או לשם המשתמש.
                </label>
              </p>

              <label htmlFor="confirm_pwd">
                אימות סיסמה:
                <FontAwesomeIcon
                  icon={faCheck}
                  className={validMatch && matchPwd ? "valid" : "hide"}
                />
                <FontAwesomeIcon
                  icon={faTimes}
                  className={validMatch || !matchPwd ? "hide" : "invalid"}
                />
              </label>
              <input
                type="password"
                id="confirm_pwd"
                onChange={(e) => setMatchPwd(e.target.value)}
                value={matchPwd}
                required
                aria-invalid={validMatch ? "false" : "true"}
                aria-describedby="confirmnote"
                onFocus={() => setMatchFocus(true)}
                onBlur={() => setMatchFocus(false)}
              />
              <p
                id="confirmnote"
                className={
                  matchFocus && !validMatch ? "instructions" : "offscreen"
                }
              >
                <FontAwesomeIcon icon={faInfoCircle} />
                שתי הסיסמאות חייבות להיות תואמות.
              </p>

              <button disabled={!validPwd || !validMatch ? true : false}>
                בצע
              </button>
            </form>
            <p>
              נרשמת כבר?
              <br />
              <span className="line">
                {/*put router link here*/}
                <a href="/login">כניסה</a>
              </span>
            </p>
          </section>
        )}
      </div>
    </>
  );
};

export default ResetPasswordConfirmation;
